import { useMutation, useQuery, useQueryClient, type UseQueryResult } from "@tanstack/react-query";

import { apiRequest } from "../../common/api/apiClient.js";
import { writeSelectedTenant } from "../../common/api/tenantStorage.js";
import type {
  CreateTenantRequest,
  CreateTenantResponse,
  OnboardingStatusDTO,
} from "../../common/api/types.js";

export const onboardingStatusKey = ["onboarding", "status"] as const;

export function useOnboardingStatus(enabled: boolean): UseQueryResult<OnboardingStatusDTO, Error> {
  return useQuery({
    queryKey: onboardingStatusKey,
    queryFn: () => apiRequest<OnboardingStatusDTO>("/onboarding/status"),
    enabled,
  });
}

/** Legt den Mandanten an und macht ihn gleich zum ausgewählten. */
export function useCreateTenant(): ReturnType<
  typeof useMutation<CreateTenantResponse, Error, CreateTenantRequest>
> {
  const client = useQueryClient();
  return useMutation<CreateTenantResponse, Error, CreateTenantRequest>({
    mutationFn: (body) =>
      apiRequest<CreateTenantResponse>("/onboarding/tenant", {
        method: "POST",
        body,
        tenant: null,
      }),
    onSuccess: (result) => {
      writeSelectedTenant(result.tenant.slug);
      void client.invalidateQueries();
    },
    onError: () => {
      void client.invalidateQueries({ queryKey: onboardingStatusKey });
    },
  });
}
